import { reportService } from './../../_services/report.service';
import { DownloadStudyBrowserReport, BestCTReportParams } from "../../_models";
import { COMMON_ACTION_TYPES, REPORT_ACTIONS } from '../../_constants';
import { exceptionHandler } from '../../_helpers';

const downloadYamazumiReport = (reportData: DownloadStudyBrowserReport, onSuccess?, onError?) => {
    return action => {
        reportService.downloadStudyBrowserReport(reportData)
        .then((response) => {
            const url = window.URL.createObjectURL(new Blob([response.data]));
            const link = document.createElement('a');
            link.href = url;
            link.setAttribute('download', 'Yamazumi Report.xlsx'); //or any other extension
            document.body.appendChild(link);
            link.click();
        })
    }
}

const getTotalCycleTimes = (factoryId: number
    , modules: string[]
    , onSuccess, onError) => {
    return action => {
        action({type: REPORT_ACTIONS.GET_TOTAL_CYCLE_TIME + COMMON_ACTION_TYPES.REQUEST})
        reportService.getTotalCycleTimes(factoryId, modules)
            .then( res => {
                action({type: REPORT_ACTIONS.GET_TOTAL_CYCLE_TIME + COMMON_ACTION_TYPES.SUCCESS, data: res.data})
                onSuccess(res.data)
            })
            .catch( error => {
                action({type: REPORT_ACTIONS.GET_TOTAL_CYCLE_TIME + COMMON_ACTION_TYPES.ERROR})
                onError(exceptionHandler.catchError(error.response))
            })
    }
}
const downloadBestCTReportData = (
    params:BestCTReportParams, onSuccess?, onError?) => {
    return action => {
        reportService.downloadBestCTReportData(params)
    }
}

const getBestCTReportData = (
    filters:BestCTReportParams
    , onSuccess, onError) => {
    return action => {
        action({type: REPORT_ACTIONS.GET_PLAN_OR_SBU_WISE_CYCLE_AND_BEST_CT_REPORT + COMMON_ACTION_TYPES.REQUEST})
        reportService.getBestCTReportData(filters)
            .then( res => {
                action({type: REPORT_ACTIONS.GET_PLAN_OR_SBU_WISE_CYCLE_AND_BEST_CT_REPORT + COMMON_ACTION_TYPES.SUCCESS, data: res.data})
                onSuccess(res.data)
            })
            .catch( error => {
                action({type: REPORT_ACTIONS.GET_PLAN_OR_SBU_WISE_CYCLE_AND_BEST_CT_REPORT + COMMON_ACTION_TYPES.ERROR})
                onError(exceptionHandler.catchError(error.response))
            })
    }
}

const getPowerBiReport = (reportType: string
    , onSuccess, onError) => {
    return action => {
        action({type: REPORT_ACTIONS.GET_BI_REPORT + COMMON_ACTION_TYPES.REQUEST})
        reportService.getPowerBiReport(reportType)
            .then( res => {
                action({type: REPORT_ACTIONS.GET_BI_REPORT + COMMON_ACTION_TYPES.SUCCESS, data: res.data})
                onSuccess(res.data)
            })
            .catch( error => {
                action({type: REPORT_ACTIONS.GET_BI_REPORT + COMMON_ACTION_TYPES.ERROR})
                onError(exceptionHandler.catchError(error.response))
            })
    }
}

export const reportActions =  {
    downloadYamazumiReport,
    getTotalCycleTimes,
    getPowerBiReport,
    getBestCTReportData,
    downloadBestCTReportData
}
